<div fxLayout="row wrap"
     *ngIf="params.isbbraun"
     fxLayout.xs="column">
     <div fxFlex="100%;"
          fxFlex.xs="100%">
          <img src="assets/bbraun/manageuser/bbrun-employee.svg"
               class="marg10"
               alt="bbrun-employee" />
     </div>
</div>
<div fxLayout="row wrap"
     *ngIf="!params.isbbraun"
     fxLayout.xs="column">
     <div fxFlex="100%;"
          fxFlex.xs="100%">
          <span class="externalUser">External User</span>
     </div>
</div>